import { ReferenceMarket } from '../../app/services/api/orderManagementClient';

export const findSelectedStoreMarket = (
  markets: ReferenceMarket[],
  franchiseUuid?: string,
): ReferenceMarket | undefined => markets.find(market => market.uuid === franchiseUuid);
